/* eslint-disable react/jsx-props-no-spreading */
import ActionsGroupProps from './types';
import StyledActionsGroup from './styled/ActionsGroup.styled';
/**
* ActionsGroup is a div used to encapsulate action elements
*/
const ActionsGroup = ({
  children, ...props
}: ActionsGroupProps) => (
  <StyledActionsGroup {...props}>
    {children}
  </StyledActionsGroup>
);

export default ActionsGroup;
